__turbopack_context__.v({
  "blurredBtn": "TopVideoSection-module__-b5Xja__blurredBtn",
  "buttonContainer": "TopVideoSection-module__-b5Xja__buttonContainer",
  "container": "TopVideoSection-module__-b5Xja__container",
  "content": "TopVideoSection-module__-b5Xja__content",
  "subTitle": "TopVideoSection-module__-b5Xja__subTitle",
  "title": "TopVideoSection-module__-b5Xja__title",
});
